export default "__VITE_ASSET__CvaX2VJ6__"